module.exports = __webpack_public_path__ + "69863789321d8b0c9ca6f674b692238a.jpg";


//////////////////
// WEBPACK FOOTER
// ./www/assets/sitios/agricolahimalaya/img/pre_cal-detail.jpg
// module id = 692
// module chunks = 0